import React from 'react';
import { FormattedMessage } from 'react-intl';

import AccountDeleteContainer from 'Components/Account/LoginAndSecurity/AccountDeleteContainer';
import AccountEmail from 'Components/Account/LoginAndSecurity/AccountEmail';
import AccountPassword from 'Components/Account/LoginAndSecurity/AccountPassword';
import Age from 'Components/Account/LoginAndSecurity/Age';
import LogOutAll from 'Components/Account/LoginAndSecurity/LogOutAll';
import TwoFactorAuthContainer from 'Components/Account/LoginAndSecurity/TwoFactorAuthContainer';

export default function LoginAndSecurity() {
  return (
    <section className="account-content">
      <h1>
        <FormattedMessage id="account-login-security.heading" defaultMessage="Login & Security" />
      </h1>
      <article className="account-table login-and-security">
        <h2 className="account-table-heading">
          <FormattedMessage id="account-login-security.login-details.title" defaultMessage="Login Details" />
        </h2>
        <AccountEmail />
        <AccountPassword />
      </article>

      <div className="account-table login-and-security">
        <div className="account-table-heading">
          <FormattedMessage id="account-login-security.personal-details.title" defaultMessage="Personal Details" />
        </div>
        <Age />
      </div>

      <article className="account-table login-and-security">
        <h2 className="account-table-heading">
          <FormattedMessage id="account-login-security.account-security.title" defaultMessage="Account Security" />
        </h2>
        <TwoFactorAuthContainer />
        <LogOutAll />
        <AccountDeleteContainer />
      </article>
    </section>
  );
}
